import { useMemo, useState } from 'react';
import {
    MRT_ColumnFiltersState,
    MRT_SortingState,
    MRT_PaginationState
} from 'material-react-table';
import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Tooltip,
} from '@mui/material';
import {
  useQuery,
} from '@tanstack/react-query';
import { type Course } from './Course.tsx'

//READ hook (get Courses from api)

//Your API response shape will probably be different. Knowing a total row count is important though.
type CourseApiResponse = {
    data: Array<Course>;
    meta: {
      totalRowCount: number;
    };
  };

export default function useGetCourses() {
    const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>(
      [],
    );
    const [globalFilter, setGlobalFilter] = useState('');
    const [sorting, setSorting] = useState<MRT_SortingState>([]);
    const [pagination, setPagination] = useState<MRT_PaginationState>({
      pageIndex: 0,
      pageSize: 10,
    });
  
    return useQuery<CourseApiResponse>({
        queryKey: [
            'table-event',
            columnFilters, //refetch when columnFilters changes
            globalFilter, //refetch when globalFilter changes
            pagination.pageIndex, //refetch when pagination.pageIndex changes
            pagination.pageSize, //refetch when pagination.pageSize changes
            sorting, //refetch when sorting changes
            ],
        queryFn: async () => {
            // Meme origine que la page (localhost:3000 en developpement,
            // le domaine du site derriere Apache en production).
            const fetchURL = new URL('/api/events', window.location.origin);
            //read our state and pass it to the API as query params
            fetchURL.searchParams.set(
                'start',
                `${pagination.pageIndex * pagination.pageSize}`,
            );
            // build headers for fetch
            const headers = new Headers();
            headers.set('Accept', 'application/json');
            const token = sessionStorage.getItem('token');
            if (token) headers.set('Authorization', 'Bearer ' + token);
            fetchURL.searchParams.set('size', `${pagination.pageSize}`);
            fetchURL.searchParams.set('filters', JSON.stringify(columnFilters ?? []));
            fetchURL.searchParams.set('globalFilter', globalFilter ?? '');
            fetchURL.searchParams.set('sorting', JSON.stringify(sorting ?? []));
            //use whatever fetch library you want, fetch, axios, etc
            const response = await fetch(fetchURL.href, { headers });
            const json = (await response.json()) as CourseApiResponse;
            return json;
        },
        refetchOnWindowFocus: false,
    });
}